


import Vue from "vue";
import RoutesDataService from "@/services/RoutesDataService"
import MapReportButton from "@/components/map-report-button/MapReportButton.vue"
import { Component } from "vue-property-decorator";
import parameters from "@/config/parameters";
import ViewWrapper from "@/components/view-wrapper/ViewWrapper.vue";
import {
  LatLng,
  LatLngBounds,
  Icon
} from "leaflet";
import {
  LMap,
  LTileLayer,
  LControlLayers,
  LPolyline,
  LControl,
  LControlZoom,
  LFeatureGroup,
  LGeoJson,
  LMarker
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
// noinspection TypeScriptCheckImport
import LProtobuf from 'vue2-leaflet-vectorgrid'
import {
  PartnershipRoutesHTTPModel,
  PilgrimPathHTTPModel,
  PartnershipRoutesModel,
  PilgrimagePathRoutesModel, StagesRoutesModel,
} from "@/models";

@Component({
  name: "Routes",
  components: {
    ViewWrapper,
    LMap,
    LTileLayer,
    LControlLayers,
    LControl,
    LControlZoom,
    LFeatureGroup,
    LPolyline,
    LGeoJson,
    LMarker,
    MapReportButton,
    LProtobuf
  },
})
export default class Routes extends Vue {
  protected retrievedData: Array<PartnershipRoutesModel>;
  public loader: boolean;

  readonly tileServer: string;
  readonly partnershipRoutes: Array<Record<string, string>>;
  readonly partnershipRoutesOptions: Record<string, unknown>;

  readonly dataRetrieverHost: string;

  fillColor: Record<number, string>;

  bounds: LatLngBounds | null;
  center: LatLng;
  zoom: number;

  tileProviders: {
    attribution: string;
    visible: boolean;
    name: string;
    url: string;
  }[];

  public focusedPartnership: null | string;
  public focusedPilgrimPath: null | string;
  public focusedStage: null | string;
  public focusedElement: null | PartnershipRoutesModel | PilgrimagePathRoutesModel | StagesRoutesModel;

  public partnershipCollapse: boolean;
  public pilgirmPathCollapse: boolean;

  isochrone;
  pois;
  poiIcon;

  readonly highlightedStyle = {
    weight: 3,
    opacity: 1,
    color: 'red'
  }

  readonly regularStyle = {
    weight: 3,
    opacity: 1,
    color: '#505050',
    'stroke-dasharray': "4"
  }

  constructor() {
    super();
    this.loader = true;
    this.fillColor = {
      1440: 'hsl(2, 100%, 47%)',
      2400: 'hsl(6, 100%, 51%)',
      4000: 'hsl(8, 100%, 53%)',
    }

    this.tileServer = parameters.mapConfiguration.tileServer;
    this.dataRetrieverHost = parameters.dataRetriever.host;

    this.partnershipRoutes = [
      {
        tileServerUrl: `${parameters.mapConfiguration.partnershipRoutesTileServerUrl}/ways-to-santiago-de-compostela/{z}/{x}/{y}.pbf`,
        slug: "ways-to-santiago-de-compostela",
        name: "Ways to Santiago de Compostela"
      },
      {
        tileServerUrl: `${parameters.mapConfiguration.partnershipRoutesTileServerUrl}/ways-to-rome/{z}/{x}/{y}.pbf`,
        slug: "ways-to-rome",
        name: "Ways to Rome"
      },
      {
        tileServerUrl: `${parameters.mapConfiguration.partnershipRoutesTileServerUrl}/ways-to-csiksomlyo/{z}/{x}/{y}.pbf`,
        slug: "ways-to-csiksomlyo",
        name: "Ways to Csiksomlyo"
      },
      {
        tileServerUrl: `${parameters.mapConfiguration.partnershipRoutesTileServerUrl}/saint-olav-ways/{z}/{x}/{y}.pbf`,
        slug: "saint-olav-ways",
        name: "Saint Olav ways"
      }
    ];
    this.partnershipRoutesOptions = {
      interactive: true,
      maxNativeZoom: 14,
      vectorTileLayerStyles: {
        "santiagodecompostela": parameters.mapConfiguration.pathStyles.partnershipRoutesBackground,
        "rome": parameters.mapConfiguration.pathStyles.partnershipRoutesBackground,
        "saintolav": parameters.mapConfiguration.pathStyles.partnershipRoutesBackground,
        "csiksomlyo": parameters.mapConfiguration.pathStyles.partnershipRoutesBackground,
      }
    };
    this.zoom = 4;
    this.center = new LatLng(56.85, 4.83); ///56.85/4.83
    this.bounds = null;

    this.tileProviders = [
      {
        attribution: "Maps &copy; <a target='_blank' href='https://www.thunderforest.com'>Thunderforest</a>, Data &copy;<a target='_blank' href='https://osm.org/copyright'>OpenStreetMap</a> contributors",
        visible: true,
        name: "Thunderforest Atlas",
        url: this.tileServer,
      },
    ];
    this.poiIcon = new Icon({
      iconUrl: require('@/assets/images/Markers/SimpleMarker.png'),
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    this.retrievedData = [];
    this.focusedElement = null;
    this.focusedPartnership = null;
    this.focusedPilgrimPath = null;
    this.focusedStage = null;

    this.partnershipCollapse = true;
    this.pilgirmPathCollapse = true;

    this.isochrone = null; 
    this.pois = null;
  }


  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public routeClicked(feature): void {
    console.log(`This is the ${feature.layer.properties.pilgrim_paths} from the ${feature.layer.properties.name}`)
    if (this.focusedPartnership === null || this.focusedPartnership !== feature.layer.properties.partnership) {
      this.focusedPartnership = feature.layer.properties.partnership;
      return;
    } else if (this.focusedPilgrimPath === null || this.focusedPilgrimPath !== feature.layer.properties.pilgrim_paths) {
      this.focusedPilgrimPath = feature.layer.properties.pilgrim_paths;
      return;
    } else {
      this.focusedStage = feature.layer.properties.name;
      return;
    }
  }

  /* Init map */

  public ready(): void {
    this.bounds = (this.$refs.routesMap as LMap).mapObject.getBounds();
  }

  /* Map events */

  public zoomUpdated(zoom: number): void {
    this.zoom = zoom;
  }
  public centerUpdated(center: LatLng): void {
    this.center = center;
  }
  public boundsUpdated(bounds: LatLngBounds): void {
    this.bounds = bounds;
  }
  public mapClicked = (): void => {
    this.focusedPartnership = null;
    this.focusedPilgrimPath = null;
    this.focusedStage = null;
    this.focusedElement = null;
    this.$forceUpdate();
  }

  /* List events */
  public partnershipClicked(partnership: PartnershipRoutesModel | Record<string, string>): void {
    this.loader = true;
    this.focusedPartnership = partnership.slug;
    this.focusedElement = (partnership as PartnershipRoutesModel) || null;
    this.loader = false;
  }

  public pilgrimPathClicked(pilgrimPath: PilgrimagePathRoutesModel): void {
    this.loader = true;
    this.focusedPilgrimPath = pilgrimPath.slug;
    this.focusedElement = pilgrimPath;
    this.loader = false;
  }

  public stageClicked(stage: StagesRoutesModel): void {
    this.loader = true;
    this.focusedStage = stage.slug;
    this.focusedElement = stage;
    this.loader = false;
  }

  public onMapElementClicked(stage: StagesRoutesModel, path: PilgrimagePathRoutesModel, partnership: PartnershipRoutesModel): void {
    this.loader = true;
    if (this.focusedPartnership !== partnership.slug) {
      this.focusedStage = null;
      this.focusedPilgrimPath = null;
      this.focusedPartnership = partnership.slug;
      this.focusedElement = partnership;
    } else if (this.focusedPilgrimPath !== path.slug) {
      this.focusedStage = null;
      this.focusedPilgrimPath = path.slug;
      this.focusedElement = path;
    } else if (this.focusedStage !== stage.slug) {
      this.focusedStage = stage.slug;
      this.focusedElement = stage;
    }
    this.$forceUpdate();
    this.loader = false;
  }

  public mounted(): void {
    this.loader = true;
    // RoutesDataService.pois()
    //   .then((response) => {
    //     this.pois = response.data
    //   })

    let partnershipsResponse: Array<PartnershipRoutesHTTPModel> = []
    RoutesDataService.getAllPartnerships()
      .then((response) => {
        partnershipsResponse = response.data
        partnershipsResponse.forEach(partnership => {
          let pilgrimpathsResponse: Array<PilgrimPathHTTPModel> = []
          let partnershipData: PartnershipRoutesModel = {
            slug: partnership.slug,
            name: partnership.name,
            geography: partnership.geography,
            length: partnership.length,
            urls: partnership.urls,
            managing_body: partnership.managing_body,
            pilgrimagePaths: []
          }
          RoutesDataService.getPilgrimagePathList(partnership.slug, partnership.pilgrimPaths)
          .then((response) => {
            pilgrimpathsResponse = response.data
            pilgrimpathsResponse.forEach(pilgrimPath => {
              let pilgrimpPathData: PilgrimagePathRoutesModel = {
                slug: pilgrimPath.slug,
                name: pilgrimPath.name,
                geography: pilgrimPath.geography,
                length: pilgrimPath.length,
                urls: pilgrimPath.urls,
                managing_body: pilgrimPath.managing_body,
                stages: []
              }
              RoutesDataService.getStageList(partnership.slug, pilgrimPath.slug, pilgrimPath.stages)
              .then((response) => {
                pilgrimpPathData.stages = response.data
              })
              .catch((e) => {
                console.log(e);
              });
              partnershipData.pilgrimagePaths.push(pilgrimpPathData)
            });
          })
          .catch((e) => {
            console.log(e);
          });
          this.retrievedData.push(partnershipData)
          this.loader = false;
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
}
